import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';
import { AddItemToInvoiceView } from './AddItemToInvoiceView';
import { InvoiceItemListView } from './InvoiceItemListView';
import * as Services from '../../../../Services/Services';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { DefaultButton, Dialog, DialogFooter, DialogType, Label, MessageBarType, PrimaryButton, Stack } from '@fluentui/react';
import { IInvoiceApi } from '../../../../Services/API/Invoice/IInvoiceApi';
import { IResult } from '../../../../Models/Result/IResult';
import AddRegistrationToInvoice from './AddRegistrationToInvoice';

interface IInvoiceItemListProps {
    invoiceId: number;
    items: IInvoiceItem[];   
    isLoading: boolean;
    isReadOnly: boolean;
    reload: () => void;
}


export const InvoiceItemList: React.FunctionComponent<IInvoiceItemListProps> = (props) => {
    const [selectedInvoiceItem, setSelectedInvoiceItem] = React.useState<IInvoiceItem>()
    const [addItemDialogVisible, setAddItemDialogVisible] = useBoolean(false)
    const [addRegistrationDialogVisible, setAddRegistrationDialogVisible] = useBoolean(false)
    
    const [deleteItemDialogVisible, setDeleteItemDialogVisible] = useBoolean(false)

    const [isLoading, setIsLoading] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();

    React.useEffect(() => {
        setIsLoading(props.isLoading);
    }, [props.isLoading])


   const propertyChanged = (key: string, value: any) => {
        if (selectedInvoiceItem) {
            setSelectedInvoiceItem({ ...selectedInvoiceItem, [key]: value });
        }
    }

    const newItem = () => {
        setSelectedInvoiceItem({
            amount: 0,
            id: 0,
            itemId: 0,
            itemName: "",
            price: 0,
            vat: 0,
            total: 0,
            totalVat: 0,
            totalWithVat: 0,
        })
        setAddItemDialogVisible.setTrue();
    }


    const addRegistration = () => {
        setSelectedInvoiceItem({
            amount: 0,
            id: 0,
            itemId: 0,
            itemName: "",
            price: 0,
            vat: 0,
            total: 0,
            totalVat: 0,
            totalWithVat: 0,
        });
        setAddRegistrationDialogVisible.setTrue();
    }

    const updateItem = async (item: IInvoiceItem) => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        if (item) {
            const result = await invoiceApi.updateInvoiceItem(props.invoiceId, item);
            if (result.isSuccess && result.data) {
                setAddItemDialogVisible.setFalse();
                setAddRegistrationDialogVisible.setFalse();
                props.reload();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading(false);
        }
    }


    const addItems = async (item: IInvoiceItem[]) => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        if (selectedInvoiceItem) {
            const result = await invoiceApi.addInvoiceItem(props.invoiceId, item);
            if (result.isSuccess && result.data) {
                setAddRegistrationDialogVisible.setFalse();
                setAddItemDialogVisible.setFalse();
                props.reload();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading(false);
        }
    }


    const updateItemStart = (item: IInvoiceItem) => {
        setSelectedInvoiceItem(item);
        setAddItemDialogVisible.setTrue();
    }

    const deleteItem =async  () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
       
        if (selectedInvoiceItem) {

            const result = await invoiceApi.removeInvoiceItem(props.invoiceId, selectedInvoiceItem.id);
            
            if (result.isSuccess && result.data) {
               
                props.reload();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading(false);
            setDeleteItemDialogVisible.setFalse();
        }
    }

    const saveItem = (item: IInvoiceItem[] | IInvoiceItem)=>
    {
        if (Array.isArray(item)) {
            addItems(item);
        }
        else {
            if (item.id == 0) {
                addItems([item]);
            }
            else {
                updateItem(item);
            }
        }
    }

    return (<Stack>
        <InvoiceItemListView
            newItem={newItem}            
            updateItem={updateItem}
            deleteItem={setDeleteItemDialogVisible.setTrue}
            items={props.items}
            selectItem={setSelectedInvoiceItem}
            isLoading={isLoading}
            isReadOnly={props.isReadOnly}
            addRegistration={addRegistration}
            selectedItem={selectedInvoiceItem}
        />
        {selectedInvoiceItem && addItemDialogVisible ?
            <AddItemToInvoiceView item={selectedInvoiceItem}
                isReadOnly={props.isReadOnly}
                isLoading={isLoading}
                isVisible={addItemDialogVisible}
                close={setAddItemDialogVisible.setFalse}
                saveItem={saveItem}
                propertyChanged={propertyChanged}
                statusMessage={statusMessage}
            />
            : null}
        {selectedInvoiceItem && addRegistrationDialogVisible ?
            <AddRegistrationToInvoice item={selectedInvoiceItem}
                isReadOnly={props.isReadOnly}
                isLoading={isLoading}
                isVisible={addRegistrationDialogVisible}
                close={setAddRegistrationDialogVisible.setFalse}
                saveItems={saveItem}
                propertyChanged={propertyChanged}
                statusMessage={statusMessage}
            />
            : null}

        {selectedInvoiceItem && deleteItemDialogVisible ?
            <Dialog hidden={!deleteItemDialogVisible}
                onDismiss={setDeleteItemDialogVisible.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Odstranění řádku z faktury',
                }}
                modalProps={{ isBlocking: true, styles: {main: { width: 450 } }, }}>
                <Stack>
                    <Label>{'Opravdu chcete odstranit položku ' + selectedInvoiceItem.itemName + ' ?'}</Label>
                </Stack>
                <DialogFooter>
                    <PrimaryButton color="red" onClick={deleteItem} text="Odstranit" />
                    <DefaultButton onClick={setDeleteItemDialogVisible.setFalse} text="Zavří" />
                </DialogFooter>
              </Dialog>
            :null}
    </Stack>
        )
}
